import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ExternalLink, Gauge } from "lucide-react";

export default function News() {
  const [news, setNews] = useState([]);
  const [fng, setFng] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/news").then((r) => {
      setNews(r.data.news || []);
      setFng(r.data.fear_greed || null);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-4 md:p-6 max-w-[1400px] mx-auto space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-display text-3xl font-extrabold">Market News</h1>
          <p className="text-sm text-slate-400 mt-1">Latest headlines moving the crypto market</p>
        </div>
        {fng && (
          <div className="flex items-center gap-3 apx-card px-4 py-2.5" data-testid="fear-greed-strip">
            <Gauge className="w-4 h-4 text-cyan-400" />
            <div>
              <div className="text-[10px] font-mono-ticker uppercase tracking-widest text-slate-500">Fear & Greed</div>
              <div className="font-mono-ticker text-lg font-bold">{fng.value} <span className="text-xs text-slate-400">{fng.value_classification}</span></div>
            </div>
          </div>
        )}
      </div>

      {loading && (
        <div className="grid gap-3">
          {Array.from({ length: 6 }).map((_, i) => <div key={i} className="skeleton h-24" />)}
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="news-list">
        {news.map((n) => (
          <a
            key={n.id} href={n.url} target="_blank" rel="noreferrer"
            data-testid={`news-${n.id}`}
            className="apx-card hover:border-cyan-800 overflow-hidden flex flex-col sm:flex-row sm:gap-4 group"
          >
            {n.image && (
              <img src={n.image} alt="" loading="lazy" referrerPolicy="no-referrer" onError={(e) => { e.currentTarget.style.display = "none"; }}
                   className="w-full h-44 sm:w-32 sm:h-32 object-cover shrink-0" data-testid={`news-image-${n.id}`} />
            )}
            <div className="p-4 min-w-0">
              <div className="flex items-center gap-2 text-[10px] font-mono-ticker uppercase tracking-widest text-slate-500">
                <span>{n.source}</span>
                <span>·</span>
                <span>{n.published ? (() => { const d = new Date(n.published); return isNaN(d.getTime()) ? "" : d.toLocaleString(); })() : ""}</span>
              </div>
              <div className="font-semibold mt-1 group-hover:text-cyan-300 transition-colors line-clamp-2">
                {n.title}
              </div>
              <div className="text-xs text-slate-400 mt-1 line-clamp-2">{n.body}</div>
              <div className="mt-2 inline-flex items-center gap-1 text-xs text-cyan-400">
                Read more <ExternalLink className="w-3 h-3" />
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
